import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {BehaviorSubject, Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {Dac6ReporterApiService} from '../../services/dac6-reporter.service';
import {ResetHallmarkKeywordCommand, UpdateArrangementChartCommand} from '../../commands/dac6-reporter.command';
import {CommandService} from '@core/services/command.service';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import { MatSelectChange } from '@angular/material/select';
import {OptionItem} from '@shared/models/option-item';

@Component({
    standalone: false,
    selector: 'particle-hallmark-tagging-dialog',
  templateUrl: './hallmark-tagging-dialog.component.html',
  styleUrls: ['./hallmark-tagging-dialog.component.scss']
})
export class HallmarkTaggingDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  inputForm: any;
  filteredOptions$: BehaviorSubject<string[]> = new BehaviorSubject([]);
  hallmarkInfo: any;
  dropdownData$: BehaviorSubject<OptionItem[]> = new BehaviorSubject([]);
  constructor(private formBuilder: FormBuilder,
              private dac6RepoterApiService: Dac6ReporterApiService,
              private commandService: CommandService) {
    this.inputForm = this.formBuilder.group({
      value: [''],
      selection: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    if (this.data.input.hallmarkInfoList) {
      this.hallmarkInfo = this.data.input.hallmarkInfoList.filter(o => o.hallmarkId === this.data.input.hallmarkId)[0];
      this.data.input.hallmarkInfo = this.hallmarkInfo;
      this.inputForm.controls['selection'].setValue(this.hallmarkInfo);
      this.dropdownData$.next(this.data.input.hallmarkInfoList);
    } else {
      this.hallmarkInfo = this.data.input.hallmarkInfo;
    }
    this.inputForm.get('value').valueChanges
      .pipe(
        startWith(''),
        map(value => {
          // console.log(value);
          if (typeof value === 'string') {
            this.filteredOptions$.next(this._filter(value));
          }
        })
      ).subscribe();
  }

  addKeyTerm() {
    const keyTerm = this.inputForm.controls['value'].value;
    if (keyTerm.length > 0 && !this.hallmarkInfo.selectedTags.includes(keyTerm)) {
      this.hallmarkInfo.selectedTags.push(keyTerm);
      this.inputForm.controls['value'].setValue('');
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return (this.hallmarkInfo == null) ? [] : this.hallmarkInfo.keywords.filter(option => option.toLowerCase().includes(filterValue));
  }

  onOkClicked(): boolean {
    this.data.input.hallmarkInfo = this.hallmarkInfo;
    return true;
  }

  removeSelectedTag(selectedTag: any) {
    this.hallmarkInfo.selectedTags = this.hallmarkInfo.selectedTags.filter(t => t !== selectedTag);
  }

  onSelectionChange($event: MatSelectChange) {
    this.hallmarkInfo = $event.value;
    this.data.input.hallmarkInfo = this.hallmarkInfo;
    this.filteredOptions$.next(this._filter(this.inputForm.get('value').value));
  }

  onOtherButtonClicked(): boolean {
    const command = new ResetHallmarkKeywordCommand(this.hallmarkInfo.id);
    this.commandService.executeCommand(command).subscribe(state => {
      if (state && state.Payload) {
        this.hallmarkInfo.keywords = state.Payload.Keywords;
        this.hallmarkInfo.selectedTags = state.Payload.SelectedTags;
      }
    });
    return false;
  }
}
